import { useMemo } from 'react';
import PropTypes from 'prop-types';

import Partner from './Partner';

const Partners = ({ title, partners }) => {
  const renderPartners = useMemo(
    () =>
      partners.map((partner) => (
        <Partner key={partner.get('id')} {...partner.toJS()} />
      )),
    [partners],
  );

  return (
    <section className="soft-half--bottom soft-double-half bordered--sides bordered--bottom">
      <h2 className="h2">
        {title || I18n.t('web.topics.partners', { count: partners.length })}
      </h2>
      <div className="grid grid--full">{renderPartners}</div>
    </section>
  );
};

Partners.propTypes = {
  partners: PropTypes.array,
  title: PropTypes.node,
};

Partners.defaultProps = {
  partners: [],
  title: null,
};

export default Partners;
